import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import PieChartCard from "./PieChartCard";
import { CATEGORY_COLORS, STATUS_COLOR } from "./constants";

export default function PieCharts({ meta, cuts, filters, onToggle }) {
  const { t } = useTranslation();

  const colorMaps = useMemo(() => {
    const byOrder = (list) =>
      (list || []).reduce((acc, o, i) => {
        acc[o.key] = CATEGORY_COLORS[i % CATEGORY_COLORS.length];
        return acc;
      }, {});
    return {
      shift: byOrder(meta?.shifts),
      lang: byOrder(meta?.languages),
    };
  }, [meta]);

  const defs = useMemo(
    () => [
      {
        id: "shift",
        title: t("schools.cutShift"),
        items: (cuts?.by_shift || []).map((c) => ({
          ...c,
          color: colorMaps.shift[c.key],
        })),
      },
      {
        id: "lang",
        title: t("schools.cutLang"),
        items: (cuts?.by_lang || []).map((c) => ({
          ...c,
          color: colorMaps.lang[c.key],
        })),
      },
      {
        id: "status",
        title: t("schools.cutStatus"),
        items: (cuts?.by_status || []).map((c) => ({
          ...c,
          color: STATUS_COLOR[c.key],
        })),
      },
    ],
    [cuts, colorMaps, t],
  );

  return (
    <div className="sch-pies">
      {defs.map((d) => (
        <PieChartCard
          key={d.id}
          def={d}
          activeKey={filters[d.id]}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
}
